import { computed, Injectable } from '@angular/core';
import { ComponentStoreV2Factory } from '../../../../shared/store/common/component-store-v2.factory';
import { FolderNoteGridItemObject } from '@libs/types/src/services/object-type/folder/folder-note.object';

@Injectable()
export class PersonNotesStore extends ComponentStoreV2Factory {

    notes = computed<FolderNoteGridItemObject[]>(() => this.data.getFolderNotes()?.items || []);

    constructor() {
        super();
    }
}
